.headerContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
}

.headerTextWithShowHideButton {
    display: flex;
    align-items: center;
}

.showHideButtonContainer {
    display: flex;
    margin-left: 15px;
}

.pageSection {
    padding: 0px 0px 20px;
    color: var(--hps-blue);
}

.row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}

.controlInformation {
    display: flex;
    align-items: center;
    margin-left: 10px;
    width: 100%;
}

.controlIdOrNameHyperlink {
    min-width: 55px;
    max-width: 50%;
}

.groupNameOrControlText {
    margin-left: 5px;
}
